import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import OverlayController from '../overlay/OverlayController';
import QueueButtonDialog from './QueueButtonDialog';
import update from 'immutability-helper';
import _ from 'lodash';


export default class QueueDialogActionButtons extends React.Component {

    static propTypes = {
        project: PropTypes.object,
        itemViewButtons: PropTypes.array,
        onItemViewButtonsChange: PropTypes.func
    };

    static defaultProps = {

    };

    constructor(props) {
        super(props);

        this.state = {
            tempButtonIdCounter: 0
        };
    }

    onAddButtonTap() {
        OverlayController.showOverlay({
            component: <QueueButtonDialog project={this.props.project} didAddButton={this.didAddButton.bind(this)} />
        });
    }

    didAddButton(data) {
        let tempButtonIdCounter = this.state.tempButtonIdCounter;
        this.props.onItemViewButtonsChange(this.props.itemViewButtons.concat({
            tempId: "tempId_" + tempButtonIdCounter,
            title: data.title,
            eventName: data.eventName,
            flowIdForUserAssignment: data.flowIdForUserAssignment
        }));
        this.setState({
            tempButtonIdCounter: tempButtonIdCounter + 1
        });
    }

    onEditButtonTap(button) {
        OverlayController.showOverlay({
            component: <QueueButtonDialog button={button} project={this.props.project} didEditButton={this.didEditButton.bind(this)} />
        });
    }

    didEditButton(data) {
        let index = this.props.itemViewButtons.findIndex(button => button.id === data.id);
        this.props.onItemViewButtonsChange(update(this.props.itemViewButtons, {
            $splice: [[index, 1, {
                hasChanged: true,
                id: data.id,
                title: data.title,
                eventName: data.eventName,
                flowIdForUserAssignment: data.flowIdForUserAssignment
            }]]
        }));
    }

    onRemoveButtonTap(removedButton) {
        if (removedButton.tempId) {
            let index = this.props.itemViewButtons.findIndex(button => button.tempId === removedButton.tempId);
            this.props.onItemViewButtonsChange(update(this.props.itemViewButtons, {
                $splice: [[index, 1]]
            }));
        } else {
            let index = this.props.itemViewButtons.findIndex(button => button.id === removedButton.id);
            this.props.onItemViewButtonsChange(update(this.props.itemViewButtons, {
                [index]: {
                    removed: {$set: true}
                }
            }));
        }
    }

    renderButtonList() {
        let style = {
            "textTransform": "none",
            "fontSize": 16
        };
        let flowMapById = _.keyBy(this.props.project.flows, 'id');
        let listItems = this.props.itemViewButtons.map(button =>
            <li className="queue-item-button-list-item" key={button.id || button.tempId}>
                <span className="queue-item-button-title">{button.title}</span>
                {button.flowIdForUserAssignment &&
                <span className="queue-item-button-feature">{flowMapById[button.flowIdForUserAssignment].name}</span>
                }
                <span className="queue-item-button-feature">{button.eventName}</span>
                <FlatButton className="queue-item-button-edit" label="Edit" primary={true} labelStyle={style} onTouchTap={() => this.onEditButtonTap(button)} />
                <FlatButton className="queue-item-button-remove" label="Remove" lprimary={true}  abelStyle={style} onTouchTap={() => this.onRemoveButtonTap(button)} />
            </li>
        );
        return (
            <ul className="queue-item-button-list">
                {listItems}
            </ul>
        );
    }

    render() {
        return (
            <div>
                {this.renderButtonList()}
                <RaisedButton
                    label="Add Button"
                    primary={true}
                    icon={<ContentAdd />}
                    onTouchTap={this.onAddButtonTap.bind(this)}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/queue/QueueDialogActionButtons.js